/**
 * Class to dynamically load a JavaScript resource file containing a dictionary of resource entries.
 */
class HicomJavascriptResourceHelper {

    /**
     * Overloaded constructor to initialize and load resources.
     * 
     * @param resourceSetName - The resource set name (e.g., "Resources.Features.Globalisation").
     * @param javascriptVariableName - The name of the JS variable that will contain the resource dictionary.
     * @param authenticatedResources - Whether the resource file requires authentication.
     * @param assemblyName - The name of the assembly containing the resources.
     */
    constructor(
        resourceSetName: string,
        javascriptVariableName: string,
        authenticatedResources: boolean,
        assemblyName: string
    ) {
        this.loadResource(resourceSetName, javascriptVariableName, authenticatedResources, assemblyName);
    }

    /**
     * Loads a JavaScript resource file containing a dictionary of resource entries.
     * 
     * @param resourceSetName - The resource set name (e.g., "Resources.Features.Globalisation").
     * @param javascriptVariableName - The name of the JS variable that will contain the resource dictionary.
     * @param authenticatedResources - Whether the resource file requires authentication.
     * @param assemblyName - The name of the assembly containing the resources.
     */
    public loadResource(
        resourceSetName: string,
        javascriptVariableName: string,
        authenticatedResources: boolean,
        assemblyName: string
    ): void {
        if (!resourceSetName) {
            throw new Error("resourceSetName is required.");
        }
        if (!javascriptVariableName) {
            throw new Error("javascriptVariableName is required.");
        }
        if (!assemblyName) {
            throw new Error("assemblyName is required.");
        }

        const cultureCode = navigator.language || "en-US"; // Get the user's UI culture

        const endpoint = authenticatedResources ? "GetDictionary" : "GetDictionaryAnonymous";
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const scriptUrl = `${hicomPage.BaseUrl}/Resource/${endpoint}?JavascriptVariableName=${encodeURIComponent(javascriptVariableName)}&AssemblyName=${encodeURIComponent(assemblyName)}&ResourceSetName=${encodeURIComponent(resourceSetName)}&CultureCode=${encodeURIComponent(cultureCode)}`;

        const scriptElement = document.createElement("script");
        scriptElement.src = scriptUrl;
        scriptElement.type = "text/javascript";
        scriptElement.async = true;

        document.head.appendChild(scriptElement);
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).HicomJavascriptResourceHelper = HicomJavascriptResourceHelper;
